import api from './api';

class PagosOficinaService {
  async createPago(data) {
    const response = await api.post('/api/pagos-oficina', data);
    return response.data;
  }

  async getPagos(filters = {}) {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.concepto) params.append('concepto', filters.concepto);
    if (filters.fecha_desde) params.append('fecha_desde', filters.fecha_desde);
    if (filters.fecha_hasta) params.append('fecha_hasta', filters.fecha_hasta);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.sort) params.append('sort', filters.sort);

    const response = await api.get(`/api/pagos-oficina?${params.toString()}`);
    return response.data;
  }

  async getPago(id) {
    const response = await api.get(`/api/pagos-oficina/${id}`);
    return response.data;
  }

  async updatePago(id, data) {
    const response = await api.patch(`/api/pagos-oficina/${id}`, data);
    return response.data;
  }

  async deletePago(id) {
    const response = await api.delete(`/api/pagos-oficina/${id}`);
    return response.data;
  }
}

export default new PagosOficinaService();